/**
 * Utility functions for transforming Air travel data
 */
import { getLocalDateFromEventDateString } from './dateUtils';

/**
 * Utility function to perform necessary transformations needed for UI
 * @param {Object} airSetupData
 * @returns {Object}
 */
export function transformAirTravelData(airSetupData) {
  const updatedAirSetupData = { ...airSetupData };
  const { defaultSchedule, restrictions, rules = [] } = updatedAirSetupData;
  if (defaultSchedule) {
    defaultSchedule.departureDate = defaultSchedule.departureDate
      ? getLocalDateFromEventDateString(defaultSchedule.departureDate) : null;
    defaultSchedule.returnDate = defaultSchedule.returnDate
      ? getLocalDateFromEventDateString(defaultSchedule.returnDate) : null;
  }
  if (restrictions) {
    restrictions.earliestDepartureDate = restrictions.earliestDepartureDate
      ? getLocalDateFromEventDateString(restrictions.earliestDepartureDate) : null;
    restrictions.latestReturnDate = restrictions.latestReturnDate
      ? getLocalDateFromEventDateString(restrictions.latestReturnDate) : null;
  }
  if (rules.length > 0) {
    updatedAirSetupData.rules = rules.map(rule => ({
      ...rule,
      earliestDepartureDate: rule.earliestDepartureDate
        ? getLocalDateFromEventDateString(rule.earliestDepartureDate) : null,
      latestReturnDate: rule.latestReturnDate
        ? getLocalDateFromEventDateString(rule.latestReturnDate) : null,
      defaultDepartureDate: rule.defaultDepartureDate
        ? getLocalDateFromEventDateString(rule.defaultDepartureDate) : null,
      defaultReturnDate: rule.defaultReturnDate
        ? getLocalDateFromEventDateString(rule.defaultReturnDate) : null
    }));
  }
  return updatedAirSetupData;
}
